export const PLAYER_EPG_TRANSACTIONS_SHOW_EPG_TRANSACTIONS =
  'PLAYER_EPG_TRANSACTIONS_SHOW_EPG_TRANSACTIONS';
export const PLAYER_EPG_TRANSACTIONS_HIDE_EPG_TRANSACTIONS =
  'PLAYER_EPG_TRANSACTIONS_HIDE_EPG_TRANSACTIONS';
